import { useEffect, useState } from "react";
import { Client, Company, Quote } from "../../types";
import Api from "../../Api";
import { B, InlineClient, InlineCompany, L, N } from "./Parts";
import DiscreetMessage from "../../parts/DiscreetMessage";
import moment from "moment";

const ContentMonitoring = ({ uuid }: { uuid: string }) => {
  const [quote, setQuote] = useState<Quote | null>(null);
  const [client, setClient] = useState<Client | null>(null);
  const [company, setCompany] = useState<Company | null>(null);

  useEffect(() => {
    Api.contractsRender(uuid).then(({ quote, client, company }) => {
      setQuote(quote);
      setClient(client);
      setCompany(company);
    });
  }, [uuid]);

  if (quote === null || client === null || company === null)
    return <DiscreetMessage text="Carregando" />;

  return (
    <div className="tracking-tight flex flex-col gap-4 py-8 pb-16 text-justify">
      <div className="text-center mb-4">
        <B>
          Contrato de prestação de serviços de monitoração e manutenção em
          alarmes eletrônicos monitorados
        </B>
      </div>

      <div>
        <B>Das partes</B>
      </div>

      <div>
        <InlineCompany company={company} /> e <InlineClient client={client} />.
      </div>

      <div>
        <N i="1" /> <B>Do objeto do contrato</B>
      </div>

      <div>
        <N i="1.1" /> Constitui objeto do presente contrato a prestação de
        serviços de Monitoramento Eletrônico no imóvel do CONTRATANTE
        identificado acima, mediante a utilização de central de monitoramento,
        profissional de Monitoramento Externo e veículo automotor tático-móvel
        (quando contratado este serviço).
      </div>

      <div>
        <N i="1.2" /> O Monitoramento consiste no recebimento de eventos
        oriundos dos equipamentos de alarme eletrônico instalados no patrimônio
        da CONTRATANTE, cujos dados serão analisados pelo profissional de
        Monitoramento Interno da central de monitoramento eletrônico da
        CONTRATADA e, em caso de anormalidades, serão transmitidos ao agente de
        atendimento que se deslocará para proceder com a vistoria externa no
        patrimônio monitorado.{" "}
      </div>

      <div>
        <N i="1.3" /> O equipamento de alarme eletrônico supramencionado é
        provido de central de sensores cuja finalidade é detectar movimentos não
        autorizados ou de procedência duvidosa no horário sob a vigilância do
        bem monitorado, dentro dos horários estipuladas pelo contratante
        conforme agenda no anexo 1.{" "}
      </div>

      <div>
        <N i="1.4" /> A CONTRATADA executará os serviços objeto do presente
        instrumento durante o período de 24 (vinte e quatro) horas
        ininterruptamente.
      </div>

      <div>
        <b>Parágrafo Primeiro.</b> Considera-se horário de monitoramento o
        período compreendido entre o acionamento do equipamento feito pelo
        usuário e o respectivo desligamento do mesmo, o qual tomara por base o
        período e dias da semana previamente ajustados na FICHA DE
        MONITORAMENTO.{" "}
      </div>

      <div>
        <b>Parágrafo Segundo.</b> São considerados movimentos não autorizados
        aqueles captados pelos sensores após o acionamento do equipamento de
        segurança, ou realizados após o desarme dos equipamentos através do
        botão de pânico (quando contratado e instalado).
      </div>

      <div>
        <b>Parágrafo Terceiro.</b> O desarme do equipamento através da senha de
        coação mesmo que tenha sido feito dentro do horário estabelecido na
        agenda será considerado suspeito e ensejará por parte da Contratada ação
        verificadora ou fiscalizadora.
      </div>

      <div>
        <b>Parágrafo Quarto.</b> O desarme do equipamento mesmo que tenha sido
        feito fora do horário estabelecido como “de segurança”, caso tenha sido
        acionado com a senha normal, será entendido pela Central de
        Monitoramento como autorizado pelo CONTRATANTE, não ensejando por parte
        da CONTRATADA qualquer ação verificadora ou fiscalizadora.
      </div>

      <div>
        <b>Parágrafo Quinto.</b> Considera-se <B>Ficha de Monitoramento</B>,
        documento que faz parte integrante do presente Instrumento, documento
        onde constará OBRIGATORIAMENTE: a) Dados Cadastrais; b) Contatos da
        CONTRATANTE em caso de disparo e anormalidades; c) Setores Monitorados;
        d) Grade de Horários (agenda); e) Descrição de Equipamentos Instalados;
        f) Palavra Chave (senha) e g) Observações Gerais.
      </div>

      <div>
        <N i="2" /> <B>DOS SERVIÇOS PRESTADOS</B>
      </div>

      <div>
        <N i="2.1" /> <b>A CONTRATADA prestará os seguintes serviços:</b>
        <Br />
        <L l="a" /> Detecção de anormalidades por acionamento do alarme: A
        CONTRATADA entrará em contato imediato, via telefone, com as pessoas
        (moradores, vizinhos, funcionários, etc.) pré- indicados pelo
        CONTRATANTE na Ficha de Monitoramento e, posteriormente, se for o caso,
        a autoridade policial.
        <Br />
        <L l="b" /> Seguir as instruções pré-definidas pelo CONTRATANTE caso o
        horário de acionamento ou desarme do equipamento deixe de ser observado,
        guardada a devida tolerância de 30 (trinta) minutos. Em caso continuo de
        inobservância da agenda por parte da contratante acarretará multa e/ ou
        alteração da agenda adaptando-a aos novos horários do arme e desarme
        utilizados.
      </div>

      <div>
        <b>Parágrafo Único.</b> Caso o alarme do CONTRATANTE dispare e em
        seguida seja desarmado com a utilização da senha normal “liga/desliga” a
        CONTRATADA entenderá ter sido o disparo acidental, razão pela qual não
        tomara qualquer providência.
      </div>

      <div>
        <N i="2.2" /> No caso de o acionamento do alarme não ter sido feito após
        ultrapassado o período de tolerância previsto na alínea “b”, a
        CONTRATADA entrará imediatamente em contrato com o CONTRATANTE para
        informá-lo sobre a ocorrência.
      </div>

      <div>
        <b>Parágrafo Único.</b> O contato previsto no caput deste item será
        feito uma única vez para cada pessoa indicada na Ficha de Monitoramento,
        não se responsabilizando a CONTRATADA por novos avisos caso o
        equipamento continue desativado.
      </div>

      <div>
        <N i="2.3" /> Acionado o alarme, além das providências descritas na
        alínea “a” do item 2.1, a CONTRATADA acionará sua viatura particular
        (quando contratada) para ir até o local da ocorrência.
      </div>

      <div>
        <b>Parágrafo Primeiro.</b> A CONTRATADA envidará todos os esforços para
        que a viatura chegue ao local da ocorrência no tempo aproximado de 15
        (quinze) minutos após o acionamento do alarme, contudo,{" "}
        <b>
          adverte-se o CONTRATANTE que tal deslocamento depende de variáveis
          como condições climáticas, trânsito e situação das estradas,
          isentando-se caso algumas dessas situações implique numa demora maior
          do que o tempo supra previsto, aqui configurado apenas como simples
          previsão e não uma obrigação de estrito cumprimento.
        </b>
      </div>

      <div>
        <b>Parágrafo Segundo.</b> O serviço de acionamento da viatura mencionado
        no parágrafo anterior será prestado somente nos seguintes dias e
        horários:
      </div>

      <div>
        <L l="a" /> Segunda a Sexta Feira das 19:00 às 07:00 horas do dia
        seguinte;
        <Br />
        <L l="b" /> Sábados a partir das 07:00 horas até as 07:00 horas da
        Segunda Feira;
        <Br />
        <L l="c" /> Feriados das 07:00 às 07 horas do dia seguinte.
      </div>

      <div>
        <b>Parágrafo Terceiro.</b> Constatada qualquer violação externa no
        patrimônio da CONTRATANTE o integrante da viatura acionará imediatamente
        a autoridade policial através do telefone 190 e juntamente com o
        CONTRATANTE ou pessoa por ele contratualmente indicada, permanecendo no
        local até a chegada dos contatados. A viatura poderá se retirar do local
        após a chegada do contratante e da autoridade policial.
      </div>

      <div>
        <N i="2.4" />{" "}
        <b>
          O CONTRATANTE expressamente reconhece que a prestação de serviço de
          monitoramento ora contrato não possui nenhuma característica de
          contrato de seguro contra furto, roubo ou dano ao patrimônio
          monitorado.
        </b>
      </div>

      <div>
        <N i="2.5" />{" "}
        <b>
          O CONTRATANTE reconhece também ser impossível a CONTRATADA garantir a
          inocorrência de eventos que venham acarretar prejuízos de ordem
          material ao imóvel monitorado, bem como danos pessoais aos habitantes
          ou frequentadores do mesmo.
        </b>
      </div>

      <div>
        <N i="2.6" />{" "}
        <b>
          O CONTRATANTE está ciente de que o equipamento instalado opera por
          sistema de telefonia fixa endereço IP (internet) ou por sistema GPRS
          (conforme escolha), portanto, sujeito a sofrer interferências que
          comprometam ou impeçam o regular funcionamento do mesmo, a título de
          exemplo, o corte da rede de telefonia fixa, cabos de internet e/ou a
          utilização de bloqueadores de sinais de telefonia móvel (jammer) e
          outros aparelhos que possam ser usados no intuito de bloquear o envio
          de sinais, utilizados pelos meliantes e, ainda, em decorrência de
          falha sistêmica oriunda das concessionárias de telefonia fixa e móvel.
        </b>
      </div>

      <div>
        <N i="2.7" /> Em função do disposto no item anterior, a CONTRATADA se
        isenta de qualquer responsabilidade por problemas na operação do
        equipamento motivados por falhas na rede pública de telecomunicações
        e/ou dos serviços de telefonia.
      </div>

      <div>
        <N i="3" /> <B>OBRIGAÇÕES DO CONTRATANTE</B>
      </div>

      <div>
        <N i="3.1" /> O CONTRANTE deverá:
        <Br />
        <L l="a" /> Fornecer normas, diretrizes e informações necessárias para
        que os serviços sejam desempenhados de acordo com as condições e
        peculiaridades dos locais a serem atendidos pelo monitoramento.
        <Br />
        <L l="b" /> Informar imediatamente a CONTRATADA de todas e quaisquer
        alterações no layout interno de suas dependências (em se tratando de
        paredes, divisórias, etc.) e/ou ampliações de qualquer natureza no
        patrimônio, afim de que seja reavaliado seu plano de segurança, e
        respeitada a quantidade e capacidade técnica dos equipamentos utilizados
        em seu sistema de segurança.
        <Br />
        <L l="c" /> Informar as mudanças de números telefônicos, dados
        cadastrais (endereços, pessoas responsáveis pela empresa, residência,
        etc.) e telefones de emergências a serem utilizados pela CONTRATADA.
        <Br />
        <L l="d" /> Fixar placa de identificação de monitoramento de alarme 24
        Horas, fornecida única e exclusivamente pela contratada, em local de
        fácil visualização.
        <Br />
        <L l="e" /> Manter inalterada a localização do equipamento de acordo com
        o projeto original de instalação, bem como zelar pela integridade do
        equipamento, e ainda impedir que pessoas não habilitadas e autorizadas
        pela CONTRATADA manuseiem o referido equipamento.
        <Br />
        <L l="f" /> Seguir os horários da agenda por ele definida continuamente
        e informar a contratada (por email e torpedo preferencialmente ou
        ligação telefônica) sempre que não puder cumprir os mesmos. A não
        observância deste item acarretará multa de 10% a título de custo
        adicional para cada evento efetuado.
      </div>

      <div>
        <N i="3.2" /> Ficarão exclusivamente por conta do CONTRATANTE todas as
        despesas com instalação, reparos e reposição de peças de seus
        equipamentos do sistema eletrônico de alarme, que deverá ser feito,
        OBRIGATORIAMENTE, por meio da CONTRATADA ou por empresa por ela
        indicada.
      </div>

      <div>
        <N i="3.3" /> A CONTRATANTE deverá realizar verificações constantes nos
        equipamentos, a fim de checar mensalmente com a central de monitoramento
        da CONTRATADA se estão em perfeito funcionamento.
      </div>

      <div>
        <N i="3.4" /> A CONTRATANTE é responsável exclusiva pela manutenção da
        linha telefônica, ou o meio de comunicação utilizado, fato indispensável
        para a comunicação do sistema de alarmes com a central de monitoramento.
      </div>

      <div>
        <b>Parágrafo Único.</b>{" "}
        <b>
          No caso de a CONTRATANTE provocar o acionamento do sistema eletrônico
          de alarme por meio de testes sem aviso prévio ao centro de operações
          da CONTRATADA, ou por esquecimento de portas e janelas abertas dos
          setores monitorados, acarretando o deslocamento de viatura e agente
          para o local, deverá ser pago a CONTRATADA, o valor de 10% (dez por
          cento) sobre o valor mensal do contrato a título de custo adicional.
        </b>
      </div>

      <div>
        <N i="3.5" /> Além das obrigações descritas nos parágrafos anteriores, a
        CONTRATANTE se obriga ainda a:
        <Br />
        <L l="a" /> Pagar o preço na forma e condições pactuadas na Cláusula
        anterior;
        <Br />
        <L l="b" /> Informar a CONTRATADA a ocorrência de quaisquer
        anormalidades no Sistema de Segurança Eletrônica;
        <Br />
        <L l="c" /> Respeitar as informações fornecidas na FICHA DE
        MONITORAMENTO;
        <Br />
        <L l="d" /> Informar a CONTRATADA todas e quaisquer alterações a serem
        feitas no acesso ao sistema de segurança como exemplo nome de novo
        usuário o tipo de acesso e telefone de contato;
        <Br />
        <L l="e" /> Informar mudança na agenda de horários quer contínuo ou
        eventual;
        <Br />
        <L l="f" /> Permitir o livre acesso em suas dependências, dos técnicos
        da CONTRATADA, para que estes procedam com a manutenção corretiva no
        sistema de segurança Eletrônica, desde que devidamente identificado pôr
        crachás e previamente autorizados, estando vedada à permanência desses
        funcionários em locais estranhos à execução dos serviços, ora
        contratados;
        <Br />
        <L l="g" /> Não permitir o acesso de pessoas estranhas a CONTRATADA
        (ex-funcionários, outros técnicos, etc.) ao sistema de segurança e
        informar quanto a necessidade de alterações a serem feitas;
        <Br />
        <L l="h" /> Não manter animais, ou permitir acesso dos mesmos em área
        protegidas por IVP; 5<Br />
        <L l="i" /> Não pendurar roupas, bandeirolas, cartazes ou qualquer
        objeto que simule movimento em áreas protegidas pôr IVP;{" "}
      </div>

      <div>
        <N i="4" /> <B>OBRIGACÕES DA CONTRATADA</B>
      </div>

      <div>
        <N i="4.1" /> A CONTRATADA deverá:
        <Br />
        <L l="a" /> Manter sua central de monitoramento devidamente equipada e
        funcionando 24 horas por dia.
        <Br />
        <L l="b" /> Atender as ocorrências citadas no item 2 nas dependências
        patrimoniais da CONTRATANTE imediatamente após a central de
        monitoramento registrar o evento, salvo motivos de força maior ou caso
        de danos provenientes de fatores climáticos ou físicos como: vendavais,
        descargas elétricas atmosféricas, fatores de calamidade pública, corte
        ou bloqueio da linha telefônica da CONTRATANTE ou falha dos
        equipamentos, esta última decorrente da não realização da checagem nos
        termos dos itens 3.3 e 3.4.
        <Br />
        <L l="c" /> Responsabilizar-se por todos os encargos trabalhistas,
        previdenciários e sociais, relativos aos empregados utilizados na
        execução dos serviços objetos deste contrato, sendo considerada a única
        empregadora para todos os efeitos legais, senso lhe expressamente vedada
        a utilização de mão de obra infantil.
        <Br />
        <L l="d" /> Fornecer as normas, diretrizes e informações necessárias
        para que os serviços sejam desempenhados de acordo com as condições e
        peculiaridades dos locais a serem atendidos pelo monitoramento.
        <Br />
        <L l="e" /> Realizar as manutenções corretiva nos equipamentos que
        compõem o sistema de alarme da contratante através de assistência
        técnica especializada gratuita de segunda a sexta feira das 08:00hrs as
        18:00hrs e sábados das 08:00hrs as 12:00hrs desde que não tenha ocorrido
        nenhuma das circunstâncias abaixo:
        <Br />
        <L l="1" pad /> Defeito ocasionado por terceiros;
        <Br />
        <L l="2" pad /> Mudança de Layout;
        <Br />
        <L l="3" pad /> Efeitos da Natureza;
        <Br />
        <L l="4" pad /> O equipamento sofra qualquer interferência de terceiros
        habilitados ou não.
        <Br />
        <L l="f" /> Manter uma “Central de Atendimento ao Cliente” que
        funcionara no horário comercial e em regime de plantão, dependendo do
        plano contratado, fora do horário comercial, por telefone, a qual ficará
        disponível ao CONTRATANTE.{" "}
      </div>

      <div>
        <b>Parágrafo Primeiro.</b> A CONTRATADA, em nenhuma hipótese, será
        responsabilizada pela instalação, manipulação, operação, manutenção ou
        qualquer outra forma de manuseio dos equipamentos de segurança por
        terceiros não autorizados.
      </div>

      <div>
        <N i="5" /> <B>DO PREÇO E DO PAGAMENTO</B>
      </div>

      <div>
        <N i="5.1" /> Pela prestação de serviços objeto deste Contrato, o
        CONTRATANTE pagará a CONTRADA a título de mensalidade acrescida dos
        valores opcionais acordados, a importância de{" "}
        <span className="text-red-600 font-bold">
          R$ 190,00 (cento e noventa reais);
        </span>
      </div>

      <div>
        <N i="5.2" /> O pagamento da primeira mensalidade pelo serviço de
        monitoramento deverá ser no momento da conclusão da instalação do
        equipamento, sendo os vencimentos das demais mensalidades para o dia
        escolhido pela CONTRATANTE.
      </div>

      <div>
        <N i="5.3" /> Além do valor pago a título de mensalidade, correrão por
        conta do CONTRATANTE os custos pelo acionamento indevido do sistema de
        segurança, conforme discriminado nos itens 3.3 e 3.4 deste Instrumento.
      </div>

      <div>
        <N i="5.4" /> Os preços referentes ao presente contrato serão
        reajustados na data de aniversário do contrato (assinatura do contrato),
        o que será feito pelo índice IPCA, ou outro índice que venha a
        substituí-lo, obtido nos doze meses do ano anterior.
      </div>

      <div>
        <N i="5.5" /> O atraso do pagamento das mensalidades importará na
        cobrança de multa moratória de 2% (dois por cento), juros monetários de
        1% (um por cento) ao mês e correção monetária sobre o valor contratado.
      </div>

      <div>
        <N i="5.6" /> O CONTRATANETE autoriza desde logo a CONTRATADA a emitir
        duplicatas de prestação de serviço para cobrança dos valores decorrentes
        do presente pacto, estando ciente de que a inadimplência acarretará no
        protesto dos citados títulos (SPC e SERASA), o que acontecerá
        independentemente de aceite, cuja falta é suprida pela assinatura do
        presente Instrumento.
      </div>

      <div>
        <b>Parágrafo Único.</b> Atraso superior a 30 (trinta) dias ocorridos
        acarretará na suspensão dos serviços até que seja efetivamente quitado o
        valor devido, sem prejuízo de outras ações cabíveis.
      </div>

      <div>
        <N i="6" /> <B>DO PRAZO DE VIGÊNCIA.</B>
      </div>

      <div>
        <N i="6.1" /> O presente contrato é celebrado pelo prazo de 12 (doze)
        meses, a contar da data de assinatura do presente Instrumento que
        ocorrerá obrigatoriamente na mesma data de instalação do equipamento,
        salvo se o CONTRATANTE pedir sua extinção, o que deverá ser feito{" "}
        <BU>por escrito e em antecedência mínima de 30 (trinta) dias</BU> da
        data de vencimento do período em curso com o ônus previsto no item a
        seguir.
      </div>

      <div>
        <b>Parágrafo Primeiro.</b> Caso o presente contrato não seja denunciado
        por qualquer das partes,{" "}
        <BU>por escrito e com antecedência mínima de 30 (trinta) dias</BU>, será
        automaticamente prorrogado por igual e sucessivo período.
      </div>

      <div>
        <b>Parágrafo Segundo.</b> Na hipótese de prorrogação automática deste
        Contrato, o valor das mensalidades será reajustado de acordo com o
        previsto no item 5.4 supra.
      </div>

      <div>
        <N i="7" /> <B>DA EXTINÇÃO E RESCISÃO.</B>
      </div>

      <div>
        <N i="7.1" /> O presente contrato poderá ser extinto antes do seu
        vencimento, a pedido do CONTRATANTE, o qual pagará a CONTRATADA{" "}
        <BU>multa compensatória</BU> de 30% (trinta por cento) da soma dos
        valores relativos as mensalidades a vencer no período restante do
        contrato.
      </div>

      <div>
        <b>Parágrafo Único.</b> Entende-se por vencimento do contrato o termo
        final de cada período de 12 (doze) meses renovado automaticamente na
        forma do parágrafo primeiro do item 6.1.
      </div>

      <div>
        <N i="7.2" /> No caso de inadimplência do CONTRATANTE por período
        superior a 30 (trinta) dias, o presente contrato poderá ser rescindido
        por decisão unilateral da CONTRATADA, hipótese em que esta notificará
        aquela por escrito (e-mail e/ou correspondência postal).
      </div>

      <div>
        <b>Parágrafo Primeiro.</b> A partir da data do recebimento da mencionada
        notificação, o contrato, será considerado extinto sem prejuízo da
        cobrança de perdas e danos por parte da CONTRATADA, inclusão das
        mensalidades em aberto e multa compensatória prevista no item anterior,
        bem como retomada do equipamento de monitoramento quando locado.
      </div>

      <div>
        <b>Parágrafo Segundo.</b> Em caso de inadimplência ficará a critério da
        CONTRATADA optar apenas pela suspensão dos serviços até a regularização
        dos valores em atraso, conforme item 5.6 e seu parágrafo único, sem que
        tal opção represente qualquer novação contratual ou gere direito a igual
        tolerância em caso de reincidência.
      </div>

      <div>
        <N i="8" /> <B>DAS CONDIÇÕES GERAIS</B>
      </div>

      <div>
        <N i="8.1" /> A senha ou palavra-chave combinada com o CONTRATANTE será
        de seu exclusivo conhecimento, competindo a ele a guarda do sigilo sobre
        elas, não se responsabilizando, a CONTRATADA, pela utilização dessas
        informações por terceiros.
      </div>

      <div>
        <N i="8.2" /> Somente o representante legal da CONTRATANTE poderá
        solicitar qualquer tipo de alteração nos dados constantes do presente
        Instrumento, ficando a CONTRATADA expressamente autorizada a deixar de
        atender solicitações feitas por terceiros, mesmo que familiares.
      </div>

      <div>
        <N i="8.3" /> A CONTRATANTE se responsabiliza por todas as informações
        contidas na FICHA DE MONITORAMENTO.
      </div>

      <div>
        <N i="8.4" /> O CONTRATANTE é responsável pela verificação periódica do
        correto funcionamento do equipamento para o fim de identificar e
        informar preventivamente a CONTRATADA eventuais problemas técnicos.
      </div>

      <div>
        <b>Parágrafo Primeiro.</b> Com o objetivo de atender o disposto no caput
        deste item, o CONTRATANTE fica autorizado, em caráter de teste, a
        solicitar um acionamento do equipamento a cada período de 30 (trinta)
        dias.
      </div>

      <div>
        <b>Parágrafo Segundo.</b> O teste mencionado no parágrafo anterior será
        realizado sem custo e deverá ser solicitado pelo telefone de prefixo da
        CONTRATADA, cumprindo obrigatoriamente informar ao atendente da
        CONTRATADA que se trata de teste técnico e não de sinistro.
      </div>

      <div>
        <N i="8.5" /> Ressalvada a hipótese de teste prevista no item anterior,
        a solicitação de acionamento do equipamento somente deverá ser feita em
        caso de ocorrência de sinistro no imóvel monitorado, caso contrário, o
        acionamento imotivado importará na cobrança de tarifa de utilização na
        fatura correspondente ao mês de referência. Será acrescido na
        mensalidade o valor referente a 10% a título de custos para cada evento
        imotivado.
      </div>

      <div>
        <N i="8.6" /> O CONTRATANTE fica responsável pela conservação do(s)
        equipamento(s), comprometendo-se a não permitir que pessoa não
        autorizada pela CONTRATADA realize qualquer espécie de intervenção
        técnica no(s) mesmo(s).
      </div>

      <div>
        <b>Parágrafo Primeiro.</b> Constará obrigatoriamente no Contrato de
        Locação de Equipamentos, caso haja, a{" "}
        <b>relação dos equipamentos de Segurança locados</b> ao CONTRATANTE.
      </div>

      <div>
        <b>Parágrafo Segundo.</b> No caso de locação dos equipamentos de
        segurança, o CONTRATANTE, ao final do contrato, seja por qual motivo
        for, deverá devolvê-los a CONTRATADA em perfeito estado de
        funcionamento, podendo responder por perdas e danos por sua negligência,
        imperícia ou imprudência, bem como pelos danos causados aos
        equipamentos.
      </div>

      <div>
        <b>Parágrafo Terceiro.</b> No caso de rescisão contratual pelo
        CONTRATANTE o mesmo deverá aguardar que a retirada do equipamento seja
        feita por pessoas autorizadas pela CONTRATADA sob pena de sofrer a
        responsabilização legal prevista no parágrafo anterior.
      </div>

      <div>
        <b>Parágrafo Quarto.</b> Se houver compra do equipamento por parte da
        CONTRATANTE, esta ficará responsável pela conservação do(s)
        equipamento(s), comprometendo-se a não permitir que pessoa não
        autorizada pela CONTRATADA realize qualquer espécie de intervenção
        técnica no(s) mesmo(s). Devendo obrigatoriamente fazer parte do presente
        Instrumento a Nota Fiscal de compra dos produtos para que seja
        identificada a relação dos equipamentos de Segurança vendidos ao
        CONTRATANTE.
      </div>

      <div>
        <N i="8.7" /> A assistência técnica somente será realizada por pessoal
        autorizado pela CONTRATADA, devendo o ônus correr pela CONTRATANTE.
      </div>

      <div>
        <N i="8.8" /> Para manutenção corretiva nos equipamentos que compõem o
        sistema de segurança eletrônica ocorrerá através de assistência técnica
        especializada, de{" "}
        <BU>
          segunda a sexta-feira, das 08:00h às 18:00h e nos sábados, das 08:00h
          às 12:00h
        </BU>
        .
      </div>

      <div>
        <b>Parágrafo Único.</b> Ocorrendo as circunstancias descrita abaixo, os
        serviços de manutenção serão cobrados pela CONTRATADA à CONTRATANTE:
      </div>

      <div>
        <L l="a" /> O defeito seja ocasionado pôr terceiros;
        <Br />
        <L l="b" /> Mudança de “lay out”;
        <Br />
        <L l="c" /> Efeitos da Natureza (inundação, raios, etc.);
        <Br />
        <L l="d" /> O equipamento tenha sofrido qualquer interferência de
        terceiros habilitados tecnicamente ou não, que não seja funcionário
        identificado da CONTRATADA;
        <Br />
        <L l="e" /> O local onde se encontra instalado o sistema de Segurança
        esteja situado a uma distância superior a 30 km da sede da CONTRATADA.
      </div>

      <div>
        <N i="8.9" /> O auxílio a qualquer sinistro não garante o impedimento da
        consumação do mesmo, nem gera tal obrigação à CONTRATADA, servindo
        apenas de apoio ás autoridades competentes, as quais continuam sendo as
        únicas responsáveis pela garantia da segurança patrimonial ou pessoal do
        CONTRATANTE, terceiros e bens abrigados no imóvel monitorado.
      </div>

      <div>
        <N i="8.10" /> Nenhuma das partes poderá ceder ou transferir, total ou
        parcialmente, quaisquer direitos ou obrigações decorrentes deste
        Contrato, sem prévio consentimento, por escrito, da outra parte,
        executando-se, porém, o direito da CONTRATADA de transferir ou ceder
        este Contrato a uma sociedade controlada, controladora ou coligada,
        direta ou indiretamente, pela mesma, mediante envio de notificação com
        15 (quinze) dias de antecedência ao CONTRATANTE.
      </div>

      <div>
        <N i="9" /> <B>DAS DISPOSIÇÕES FINAIS</B>
      </div>

      <div>
        <N i="9.1" /> O CONTRATANTE, ao assinar o presente Instrumento, declara
        ter sido devidamente instruído pela CONTRATADA sobre o correto
        funcionamento do equipamento, bem como de que leu, está ciente e
        concorda com todas as cláusulas aqui dispostas.
      </div>

      <div>
        <N i="9.2" />{" "}
        <b>
          O CONTRATANTE reconhece que os serviços prestados pela CONTRATADA é
          uma atividade de meio e não de resultado, eis que a CONTRATADA não
          realiza nem pratica nenhuma ação direta contra os acontecimentos
          denunciados pelo sinal de legislação vigente e que a efetiva prestação
          dos serviços de Monitoramento Eletrônico terá início tão somente após
          a instalação do sistema de alarme, devendo ser observado que a
          CONTRATADA resguarda a si um prazo de 24 (vinte e quatro horas), após
          o recebimento da ordem de serviço, para a instalação em definitivo, de
          todas as providências contidas no presente Instrumento;
        </b>
      </div>

      <div>
        <N i="9.3" />{" "}
        <b>
          A CONTRATANTE, neste ato, DECLARA e RECONHECE que a{" "}
          <BU>CONTRATADA NÃO É COMPANHIA DE SEGURO</BU>, portanto não se
          responsabiliza por quaisquer perdas ou danos materiais que por
          qualquer motivo possam advir a contratante ou a terceiros. A
          CONTRATANTE reconhece ainda, que em havendo furto/roubo de objetos,
          dinheiro em espécie, etc. (bens materiais) de sua propriedade e/ou de
          terceiros em seu estabelecimento, não será de responsabilidade da
          CONTRATADA o ressarcimento, exceto quando comprovada a falha na
          prestação de serviços.
        </b>
      </div>

      <div>
        <N i="9.4" /> A RESPONSABILIDADE da CONTRATADA está limitada ao escopo
        deste Instrumento de Contrato, ou seja, caso seja comprovado que houve
        alguma falha técnica ou humana cumulada com a ocorrência de roubo ou
        furto qualificado, com destruição ou rompimento de obstáculos, na
        prestação dos serviços contratados, a CONTRATADA a título de
        compensação, se obriga a ressarcir a CONTRATANTE até o limite de{" "}
        <b>oito mensalidades</b> previstas na cláusula Quarta, até 40 dias após
        a comprovação da falha na prestação de serviços;
      </div>

      <div>
        <N i="9.5" /> A CONTRATADA não se responsabiliza por danos causados em
        portas, vidros, fechaduras, trincos, outros obstáculos que visam impedir
        o acesso ao bem protegido.
      </div>

      <div className="flex flex-col gap-4 break-inside-avoid">
        <div>
          <N i="9.6" /> Para dirimir quaisquer controvérsias oriundas do
          presente contrato, as partes elegem o foro da comarca de Vitória/ES,
          independentemente de qualquer outra, por mais privilegiada que seja.
          E, por estarem justas e pactuadas, as Partes assinam o presente
          Contrato em 02 (duas) vias de igual teor e forma para um só efeito, na
          presença das testemunhas abaixo.
        </div>

        <div className="text-center my-4">
          Vitória/ES, {moment.utc().format("DD [de] MMMM [de] YYYY")}
        </div>

        <div className="text-center mt-16">
          <B>{company.name}</B>
          <div>(Contratada)</div>
        </div>

        <div className="text-center mt-16">
          <B>{client.name}</B>
          <div>(Contratante)</div>
        </div>
      </div>
    </div>
  );
};

export default ContentMonitoring;

const Br = () => <div className="h-1.5" />;

const BU = ({ children }: { children: React.ReactNode }) => (
  <strong className="underline">{children}</strong>
);
